import AuthLayout from "../layout/AuthLayout";
import LoginForm from "./_features/components/LoginForm";

const LoginPage = () => {
  return (
    <AuthLayout>
      <LoginForm />
    </AuthLayout>
  );
};

export default LoginPage;
